import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ngx-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  @Input() value: string;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() dropdownOptions: { id: string, name: string }[];
  @Input() selectedOption: string;
  @Output() selectedOptionChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    if (this.dropdownOptions && this.dropdownOptions[0]) this.selectedOption = this.dropdownOptions[0].id;
  }

  update($event) {
    this.valueChange.emit($event);
  }

  onColumn($event) {
    this.selectedOptionChange.emit($event);
  }
}
